import { Component, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { RouterOutlet } from '@angular/router';
import { DialogComponent } from './shared/dialog/dialog.component';
import { environment } from '../environments/environment';

declare global {
  interface Window {
    dataLayer: any[];
  }
}

@Component({
  selector: 'app-root',
  imports: [RouterOutlet],
  templateUrl: './app.component.html',
  styleUrl: './app.component.scss',
})
export class AppComponent implements OnInit {
  public canCloseDialog = false;
  public constructor(private readonly _dialog: MatDialog) {
    const isLocalhost = location.hostname === 'localhost';
    // 正式環境不顯示彈窗
    if (environment.production || isLocalhost) return;
    if (location.hash === '#canCloseDialog') this.canCloseDialog = true;
    this._dialog.open(DialogComponent, {
      data: {
        title: '活動建置中',
        content: '活動將於 2025/07/07 啟動',
      },
      disableClose: !this.canCloseDialog,
    });
  }

  ngOnInit() {
    const script = document.createElement('script');
    script.async = true;
    script.src = `https://www.googletagmanager.com/gtag/js?id=${environment.googleAnalyticsId}`;
    document.head.appendChild(script);

    window.dataLayer = window.dataLayer || [];
    function gtag(...args: any[]) { window.dataLayer.push(arguments); }
    gtag('js', new Date());
    gtag('config', environment.googleAnalyticsId);
  }
}
